let healthRecord = function (tokenClient, serviceAddr) {
    let TokenClient = tokenClient;
    let ServiceBaseAddress = serviceAddr;


    // 健康管理
    /**
     * @param {any} success
     * @param {any} error
     */
    this.GetSelfDiagnosis = function (userId,serchWord,pageIndex,serchWorddName,serchWorddResult,success, error) {
        var url = ServiceBaseAddress + '/api/UserSelfDiagnosisRecord/SelfDiagnosis/%20/'
        + userId + '/%20/%20/' + serchWord  + '/' + pageIndex + '/' + serchWorddName + '/' + serchWorddResult;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetRealNameAuthByUser = function (id,success, error) {
        var url = ServiceBaseAddress + '/api/RealNameAuth/GetRealNameAuthByUser/' + id
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetHealthRecordSignInfo = function (id,success, error) {
        var url = ServiceBaseAddress + '/api/HealthRecordSign/GetHealthRecordSignInfo/' + id
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetUserResultByUser = function (userId,serchWord,pageIndex,serchWorddName,serchWorddResult,Qid,success, error) {
        var url = ServiceBaseAddress + '/api/Questionnaire/UserResultByUser/'
        + userId + '/' + serchWord  + '/' + pageIndex + '/' + serchWorddName + '/' + serchWorddResult + '/' + Qid;
        TokenClient.Get(url, true, null, null,
        function (data) {
            if (success) {
                var jsonObj = JSON.parse(data);
                success(jsonObj);
            }
        }, error);
    }
    this.GetTCMDisease = function (id,keyword,pageIndex,success, error) {
        var url = ServiceBaseAddress + '/api/UserSelfDiagnosisRecord/TCMDisease/' + id + '/%20/%20/' + keyword + '/' + pageIndex;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetResult = function (id,success, error) {
        var url = ServiceBaseAddress + '/api/UserSelfDiagnosisRecord/Result/' + id;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetQuestionnaire = function (success, error) {
        var url = ServiceBaseAddress + '/api/Questionnaire';
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetPatientHealthPresscription = function (id,start,end,pageIndex,pageSize,success, error) {
        var url = ServiceBaseAddress + '/api/MZDrug/GetPatientHealthPresscription/' + id + '/' + start + '/' + end + '/' + pageIndex + '/' + pageSize;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetHealthUserOrderListCon = function (id,start,end,pageIndex,pageSize,success, error) {
        var url = ServiceBaseAddress + '/api/ConsultationOrder/GetHealthUserOrderList/' + id + '/' + start + '/' + end + '/' + pageIndex + '/' + pageSize;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetHealthUserOrderList = function (id,start,end,pageIndex,pageSize,success, error) {
        var url = ServiceBaseAddress + '/api/DoctorAppointmentOrder/GetHealthUserOrderList/' + id + '/' + start + '/' + end + '/' + pageIndex + '/' + pageSize;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.OrderDetail = function (id,success, error) {
        var url = ServiceBaseAddress + '/api/DoctorAppointmentOrder/OrderDetail/' + id;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.OrderDetailcos = function (id,success, error) {
        var url = ServiceBaseAddress + '/api/ConsultationOrder/OrderDetail/' + id;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
   
    this.IsVerify = function (phone,coded,success, error) {
        var url = ServiceBaseAddress + '/api/VerificationCode/IsVerify/' + phone + '/' +coded;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.SendVerifyCode = function (phone,success, error) {
        var url = ServiceBaseAddress + '/api/VerificationCode/SendVerifyCode/' + phone;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.ExistHealthRecord = function (phone,success, error) {
        var url = ServiceBaseAddress + '/api/HealthRecord/ExistHealthRecord/%20/' + phone;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.EnableMedicationReminders = function (healthRecordId,success, error) {
        var url = ServiceBaseAddress + '/api/HealthRecordMedicationReminder/EnableMedicationReminders/' + healthRecordId;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetMedicationReminder = function (healthRecordId,success, error) {
        var url = ServiceBaseAddress + '/api/HealthRecordMedicationReminder/GetMedicationReminder/' + healthRecordId;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetMedicationRecord = function (healthRecordId,drugSetTime,pageIndex, pageSize,success, error) {
        var url = ServiceBaseAddress + '/api/HealthRecordMedicationReminder/GetMedicationRecord/' + healthRecordId + '/' + drugSetTime +'/' + pageIndex + '/' + pageSize;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetUserVaccinationList = function (id,type, success, error) {
        var url = ServiceBaseAddress + '/api/UserVaccination/GetUserVaccinationList/' + id + '/' + type;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetVaccinationInfo = function (id,success, error) {
        var url = ServiceBaseAddress + '/api/Vaccination/GetVaccinationInfo/' + id;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.ViewDisease = function (id, success, error) {
        var url = ServiceBaseAddress + '/api/Diseases/Manager/ViewDisease/' + id;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetDicConfigByType = function (success, error) {
        var url = ServiceBaseAddress + '/api/DictConfig/GetDicConfigByType/2/241dbbb33cea792c1b92280da0a5edd4';
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.SearchDiseases = function (keyWord, success, error) {
        var url = ServiceBaseAddress + '/api/Diseases/Manager/SearchDiseases/1/' + keyWord;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetUserChronicDiseaseList = function (id, success, error) {
        var url = ServiceBaseAddress + '/api/UserChronicDisease/GetUserChronicDiseaseList/' + id;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetSymptomList = function (id,keyWord, success, error) {
        var url = ServiceBaseAddress + '/api/MZSymptom/GetSymptomList/' + id + '/' + keyWord;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetHealthBasicInfo = function (id, success, error) {
        var url = ServiceBaseAddress + '/api/HealthBasicInfo/GetHealthBasicInfo/' + id;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetBloodPressureRecordPage = function (id,pageIndex,pageSize, success, error) {
        var url = ServiceBaseAddress + '/api/BloodPressureRecord/GetBloodPressureRecordPage/' + id + '/' + pageIndex + '/' + pageSize;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetBmiRecordPage = function (id,pageIndex,pageSize, success, error) {
        var url = ServiceBaseAddress + '/api/BmiRecord/GetBmiRecordPage/' + id + '/' + pageIndex + '/' + pageSize;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetBloodSugarRecordPage = function (id,pageIndex,pageSize, success, error) {
        var url = ServiceBaseAddress + '/api/BloodSugarRecord/GetBloodSugarRecordPage/' + id + '/' + pageIndex + '/' + pageSize;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetUserHealthRecordRole = function (id, success, error) {
        var url = ServiceBaseAddress + '/api/User/GetUserHealthRecordRole/' + id;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetBmiStatisticsByDays = function (id, success, error) {
        var url = ServiceBaseAddress + '/api/BmiRecord/GetBmiStatisticsByDays/' + id;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetBloodPressureStatisticsByDays = function (id, success, error) {
        var url = ServiceBaseAddress + '/api/BloodPressureRecord/GetBloodPressureStatisticsByDays/' + id;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetBloodPressureStatisticsSummary = function (id, success, error) {
        var url = ServiceBaseAddress + '/api/BloodPressureRecord/GetBloodPressureStatisticsSummary/' + id;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetBmiStatisticsSummary = function (id, success, error) {
        var url = ServiceBaseAddress + '/api/BmiRecord/GetBmiStatisticsSummary/' + id;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GettBloodSugarStatisticsByDays = function (id, success, error) {
        var url = ServiceBaseAddress + '/api/BloodSugarRecord/GettBloodSugarStatisticsByDays/' + id;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GettBloodSugarStatisticsSummary = function (id, success, error) {
        var url = ServiceBaseAddress + '/api/BloodSugarRecord/GettBloodSugarStatisticsSummary/' + id;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetHealthRecordFamilyInfo = function (id, success, error) {
        var url = ServiceBaseAddress + '/api/HealthRecord/GetHealthRecordFamilyInfo/' + id;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetHealthRecordByHealthId = function (id, success, error) {
        var url = ServiceBaseAddress + '/api/HealthRecord/GetHealthRecordByHealthId/' + id;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetHealthRecordNotSignUserInfo = function (keyWord, success, error) {
        var url = ServiceBaseAddress + '/api/HealthRecordSign/GetHealthRecordNotSignUserInfo/' + keyWord;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetHealthRecordUserSignByDoctor = function (params, success, error) {
        var url = ServiceBaseAddress + '/api/HealthRecordSign/GetHealthRecordUserSignByDoctor/' + params;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetHealthRecordDoctorNotSignCount = function (num, success, error) {
        var url = ServiceBaseAddress + '/api/HealthRecordSign/GetHealthRecordDoctorNotSignCount/' + num;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetUserHealthRecordRole = function (params, success, error) {
        var url = ServiceBaseAddress + '/api/User/GetUserHealthRecordRole/' + params;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.GetHealthRecordByHealthId = function (params, success, error) {
        var url = ServiceBaseAddress + '/api/HealthRecord/GetHealthRecordByHealthId/' + params;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }
    this.BreakHealthRecordSign = function (item, success, error) {
        var url = ServiceBaseAddress + "/api/HealthRecordSign/BreakHealthRecordSign";
        TokenClient.Post(
            url,
            true,
            { "Content-Type": "application/json" },
            item,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            },
            error
        );
    };
    this.AuditHealthRecordSign = function (item, success, error) {
        var url = ServiceBaseAddress + "/api/HealthRecordSign/AuditHealthRecordSign";
        TokenClient.Post(
            url,
            true,
            { "Content-Type": "application/json" },
            item,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            },
            error
        );
    };
    this.GetHeardRecordNotReadMessage = function (item, success, error) {
        var url = ServiceBaseAddress + "/api/ChatHub/GetHeardRecordNotReadMessage";
        TokenClient.Post(
            url,
            true,
            { "Content-Type": "application/json" },
            item,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            },
            error
        );
    };
    this.GetHeardRecordFamilyNotReadMessage = function (item, success, error) {
        var url = ServiceBaseAddress + "/api/ChatHub/GetHeardRecordFamilyNotReadMessage"
        TokenClient.Post(
            url,
            true,
            { "Content-Type": "application/json" },
            item,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            },
            error
        );
    };
    this.SendSignRemind = function (item, success, error) {
        var url = ServiceBaseAddress + "/api/HealthRecordSign/SendSignRemind/" + item
        TokenClient.Post(
            url,
            true,
            { "Content-Type": "application/json" },
            null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            },
            error
        );
    };
    this.AddHealthRecordSign = function (item, success, error) {
        var url = ServiceBaseAddress + "/api/HealthRecordSign/AddHealthRecordSign"
        TokenClient.Post(
            url,
            true,
            { "Content-Type": "application/json" },
            item,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            },
            error
        );
    };
    
    this.getWXQrCode = function (item, success, error) {
        var url = ServiceBaseAddress + "/api/WXQrCode/QRCode"
        TokenClient.Post(
            url,
            true,
            { "Content-Type": "application/json" },
            item,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            },
            error
        );
    };
    this.SubmitBmiRecord = function (item, success, error) {
        var url = ServiceBaseAddress + "/api/BmiRecord/SubmitBmiRecord"
        TokenClient.Post(
            url,
            true,
            { "Content-Type": "application/json" },
            item,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            },
            error
        );
    };
    this.SubmitBloodSugarRecord = function (item, success, error) {
        var url = ServiceBaseAddress + "/api/BloodSugarRecord/SubmitBloodSugarRecord"
        TokenClient.Post(
            url,
            true,
            { "Content-Type": "application/json" },
            item,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            },
            error
        );
    };
    this.SubmitBloodPressureRecord = function (item, success, error) {
        var url = ServiceBaseAddress + "/api/BloodPressureRecord/SubmitBloodPressureRecord"
        TokenClient.Post(
            url,
            true,
            { "Content-Type": "application/json" },
            item,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            },
            error
        );
    };
    this.SubmitHealthBasicInfo = function (item, success, error) {
        var url = ServiceBaseAddress + "/api/HealthBasicInfo/SubmitHealthBasicInfo"
        TokenClient.Post(
            url,
            true,
            { "Content-Type": "application/json" },
            item,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            },
            error
        );
    };
    this.SubmitUserChronicDisease = function (item, success, error) {
        var url = ServiceBaseAddress + "/api/UserChronicDisease/SubmitUserChronicDisease"
        TokenClient.Post(
            url,
            true,
            { "Content-Type": "application/json" },
            item,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            },
            error
        );
    };
    this.SubmitUserVaccination = function (item, success, error) {
        var url = ServiceBaseAddress + "/api/UserVaccination/SubmitUserVaccination"
        TokenClient.Post(
            url,
            true,
            { "Content-Type": "application/json" },
            item,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            },
            error
        );
    };
    this.SetMedicationRecordStatus = function (item, success, error) {
        var url = ServiceBaseAddress + "/api/HealthRecordMedicationReminder/SetMedicationRecordStatus"
        TokenClient.Post(
            url,
            true,
            { "Content-Type": "application/json" },
            item,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            },
            error
        );
    };
    this.UpdateMedicationReminder = function (item, success, error) {
        var url = ServiceBaseAddress + "/api/HealthRecordMedicationReminder/UpdateMedicationReminder"
        TokenClient.Post(
            url,
            true,
            { "Content-Type": "application/json" },
            item,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            },
            error
        );
    };
    this.AddMedicationReminder = function (item, success, error) {
        var url = ServiceBaseAddress + "/api/HealthRecordMedicationReminder/AddMedicationReminder"
        TokenClient.Post(
            url,
            true,
            { "Content-Type": "application/json" },
            item,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            },
            error
        );
    };
    this.AddHealthRecordFamilyUser = function (item, success, error) {
        var url = ServiceBaseAddress + "/api/HealthRecord/AddHealthRecordFamilyUser"
        TokenClient.Post(
            url,
            true,
            { "Content-Type": "application/json" },
            item,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            },
            error
        );
    };
    this.SubmitRealNameAuth = function (item, success, error) {
        var url = ServiceBaseAddress + "/api/RealNameAuth/SubmitRealNameAuth"
        TokenClient.Post(
            url,
            true,
            { "Content-Type": "application/json" },
            item,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            },
            error
        );
    };
    this.UpdateFamilyName = function (item, success, error) {
        var url = ServiceBaseAddress + "/api/HealthRecord/UpdateFamilyName"
        TokenClient.Post(
            url,
            true,
            { "Content-Type": "application/json" },
            item,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            },
            error
        );
    };
    
}
export { healthRecord }